module.exports = __webpack_public_path__ + "static/media/my_stories_active.e34d9711.svg";